/* ODDORA — interacciones propias (sin librerías) */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.od-reveal:not(.od-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('od-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('od-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria(root) {
    var principal = root.querySelector('[data-od-principal]');
    if (!principal) return;
    root.querySelectorAll('[data-od-mini]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-od-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
        btn.classList.add('is-activa');
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = '';
          principal.alt = btn.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 180);
      });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  function initProducto(root) {
    var dataEl = root.querySelector('[data-od-variantes]');
    var form = root.querySelector('[data-od-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-od-boton]');
    var botonTexto = boton ? boton.querySelector('span') : null;
    var textoComprar = boton ? boton.getAttribute('data-texto') : '';
    var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';
    var moneyFormat = root.getAttribute('data-money-format');
    var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];

    function actualizar(v) {
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('[data-od-precio]').forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      root.querySelectorAll('[data-od-precio-antes]').forEach(function (el) {
        el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, moneyFormat) : '';
      });
      if (boton) {
        boton.disabled = !v.available;
        if (botonTexto) botonTexto.textContent = v.available ? textoComprar : textoAgotado;
      }
      var punto = root.querySelector('.od-compra__punto');
      if (punto) punto.classList.toggle('is-agotado', !v.available);
      var aviso = root.querySelector('[data-od-aviso]');
      if (aviso) aviso.textContent = v.available ? aviso.getAttribute('data-ok') : aviso.getAttribute('data-no');
      if (v.featured_image && v.featured_image.src) {
        var principal = root.querySelector('[data-od-principal]');
        if (principal) { principal.src = v.featured_image.src; principal.srcset = ''; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-od-opcion]').forEach(function (input) {
      input.addEventListener('change', function () {
        var elegidas = [];
        root.querySelectorAll('[data-od-grupo]').forEach(function (grupo) {
          var sel = grupo.querySelector('input:checked');
          elegidas.push(sel ? sel.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (v) actualizar(v);
        else if (boton) { boton.disabled = true; if (botonTexto) botonTexto.textContent = textoAgotado; }
      });
    });

    var qty = form.querySelector('[data-od-qty]');
    root.querySelectorAll('[data-od-pack]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked && qty) qty.value = r.value; });
    });
    root.querySelectorAll('[data-od-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        n += parseInt(b.getAttribute('data-od-qty-btn'), 10);
        qty.value = Math.max(1, n);
        root.querySelectorAll('[data-od-pack]').forEach(function (r) { r.checked = String(r.value) === String(qty.value); });
      });
    });

    form.addEventListener('submit', function (ev) {
      var drawer = document.querySelector('cart-drawer');
      var notif = document.querySelector('cart-notification');
      var cart = drawer || notif;
      if (!cart || !window.fetch) return; // envío normal del formulario
      ev.preventDefault();
      var err = root.querySelector('.od-compra__error');
      if (err) err.style.display = 'none';
      boton.disabled = true;
      boton.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      var secciones = cart.getSectionsToRender().map(function (s) { return s.section || s.id; });
      fd.append('sections', secciones.join(','));
      fd.append('sections_url', window.location.pathname);
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || res.message; err.style.display = 'block'; }
            return;
          }
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          cart.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          boton.disabled = false;
          boton.removeAttribute('aria-busy');
        });
    });

    // Barra fija de compra en móvil
    var barra = document.querySelector('[data-od-barra]');
    if (barra && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      });
      io.observe(form);
      var botonBarra = barra.querySelector('button');
      if (botonBarra) botonBarra.addEventListener('click', function () {
        if (boton && !boton.disabled) boton.click();
      });
    }
  }

  function init() {
    initReveals();
    document.querySelectorAll('[data-od-producto]').forEach(function (root) {
      initGaleria(root);
      initProducto(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de Shopify: volver a iniciar al recargar una sección
  document.addEventListener('shopify:section:load', init);
})();
